import type { FaireProductEntity } from "../../entity_types/product";

export const p_b9dm8btcqc: FaireProductEntity = {
  token: "p_b9dm8btcqc",
  type: "product",
  name: "Organic Cotton Muslin Baby Dress",
  brandToken: "b_6ubkgarv",
  brandName: "Newcastle Classics",
  imageUrl:
    "https://cdn.faire.com/fastly/4141fc0165b7d5bdfbd4bf42f8c6eecaade417c9c462a87a67bffe7372d51ec2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b8dffadb940761d709579972bb9375d6651390a5680f64ed8088100d13aa3e9.jpeg",
    "https://cdn.faire.com/fastly/84d253acadd3081d62cd884fb284c8933b4697f6f403945e0ca170360a3c546f.jpeg",
    "https://cdn.faire.com/fastly/d5f9b6a3e251882609940af1c873fcedc3968921e6c67e2bb3e4acd352d9348d.jpeg",
    "https://cdn.faire.com/fastly/93333374b642b7e73057d6722076aded627b1bb419e13f560b6e6fd316e022b5.jpeg",
    "https://cdn.faire.com/fastly/df004cc4ab5cd6f0447da9215433f1cbe57a4e328a882b4a568fae5922300b30.jpeg",
    "https://cdn.faire.com/fastly/ce071046aafbd822a5644320bf9702347a8dec5bc74ad000f9d610beda499e30.jpeg",
    "https://cdn.faire.com/fastly/db7c5f992d06e3a8b1a24df1d968c2a74fa193a936694fad21902ad192cedc35.jpeg",
  ],
  priceDollars: 15,
  description:
    "\nLight and soft organic cotton dress. Wear on its own or with a onesie underneath for added warmth. This cute and stylish dress is perfect for all occasions. Made from Organic Cotton, available in 3 colors and multiple sizes.\n\n100% Organic Cotton Muslin Button Strap Textured Dress\n\n\n\n\n\n",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:05.601Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
